module.exports = __webpack_public_path__ + "img/lock.c1ff18c4.svg";